/*==========================================================
CONTRAST MODE SCRIPT
==========================================================*/
var contrastMode = false;

function toast() {
    var x = document.getElementById('toastContrast');
    x.classList.add('show');
    setTimeout(function () {
        x.classList.remove('show');
    }, 2000);
}

$(function () {
    $('.contrastSwitcher').on('click', function (event) {
        contrastControl($(this), event);
    });

    $('.defaulContrast').on('click', function () {
        contrastControl($(this), event);
    })

    function contrastControl(el, e) {
        e.preventDefault();

        var me = $(el);
        me.blur();

        var lang = iCreateObject.lang === undefined ? "en" : iCreateObject.lang;
        var contrastTextToastOn = iCreateObject.languageResources === undefined || iCreateObject.languageResources.Common_contrastIncreaseToast === undefined ? (lang == "fr" ? "Le mode de contraste �lev� est activ�" : "High Contrast Mode is on") : iCreateObject.languageResources.Common_contrastIncreaseToast;
        var contrastTextToastOff = iCreateObject.languageResources === undefined || iCreateObject.languageResources.Common_contrastDecreaseToast === undefined ? (lang == "fr" ? "Le mode contraste �lev� est d�sactiv�" : "High Contrast Mode is off") : iCreateObject.languageResources.Common_contrastDecreaseToast;
        var contrastTextOn = iCreateObject.languageResources === undefined || iCreateObject.languageResources.Common_contrastIncrease === undefined ? (lang == "fr" ? "Augmenter le contraste" : "Increase Contrast") : iCreateObject.languageResources.Common_contrastIncrease;
        var contrastTextOff = iCreateObject.languageResources === undefined || iCreateObject.languageResources.Common_contrastDecrease === undefined ? (lang == "fr" ? "Diminuer le contraste" : "Decrease Contrast") : iCreateObject.languageResources.Common_contrastDecrease;

        if (contrastMode) {
            $('html').removeClass('contrast-mode');
            contrastMode = false;
            $('#toastContrast').empty().append('<p>' + contrastTextToastOff + '</p>');
            $('a.contrastSwitcher').text(contrastTextOn);
            toast();
            $('.contrastSwitcher').removeClass('current');
            $('.defaulContrast').addClass('current');
        } else {
            $('html').addClass('contrast-mode');
            contrastMode = true;
            $('#toastContrast').empty().append('<p>' + contrastTextToastOn + '</p>');
            $('a.contrastSwitcher').text(contrastTextOff);
            toast();
            $('.defaulContrast').removeClass('current');
            $('.contrastSwitcher').addClass('current');
        }
    }
});
